// components/ui/Modal.tsx
import { ReactNode } from "react";

export default function Modal({
    isOpen,
    onClose,
    title,
    children,
    closeOnOverlayClick = true,
    panelClassName = "",
    hideHeader = false,
}: {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: ReactNode;
    closeOnOverlayClick?: boolean;
    panelClassName?: string;
    hideHeader?: boolean;
}) {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            onClick={() => {
                if (closeOnOverlayClick) onClose();
            }}
        >
            <div
                className={`bg-white rounded-lg p-6 w-full max-w-md ${panelClassName}`}
                onClick={(e) => e.stopPropagation()}
            >
                {!hideHeader && (
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="text-xl font-bold">{title}</h3>
                        <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                            ×
                        </button>
                    </div>
                )}
                {children}
            </div>
        </div>
    );
}
